import { isEqual } from "lodash";

type Schema = Record<string, unknown>;

function schemaDefault(schema: Schema, key: string): unknown {
  const entry = schema[key];
  return entry && typeof entry === "object" && "default" in entry
    ? (entry as { default: unknown }).default
    : undefined;
}

/**
 * True when `after` differs from `before` only by adding keys that sit at
 * their schema default. The config panel's fields register those defaults
 * into the form on mount and the panel flushes them back, so such a write is
 * not an edit the user made: it gets no undo entry and does not dirty the
 * flow. Any changed, removed or non-default added key makes it a real edit.
 */
export function onlyMaterializesDefaults(
  before: Record<string, unknown>,
  after: Record<string, unknown>,
  schema: Schema
): boolean {
  if (Object.keys(before).some((key) => !(key in after))) return false;
  let added = false;
  for (const [key, value] of Object.entries(after)) {
    if (key in before) {
      if (!isEqual(before[key], value)) return false;
      continue;
    }
    if (!(key in schema) || !isEqual(value, schemaDefault(schema, key)))
      return false;
    added = true;
  }
  return added;
}
